import {createActions} from 'client/framework';

const normalActions = ['SET_SORT_BY', 'SET_IS_MOBILE'];

export default createActions(null, normalActions);
